import React, { useState } from "react";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from '@mui/styles';
import Typography from "@mui/material/Typography";

import pxToRem from "libs/pxToRem";
import {
  ESituacionOperacion,
  SITUACION_OPERACION_CODES,
} from "domain/types";

const codigo = (situacion) => SITUACION_OPERACION_CODES[situacion];

//Cuando salga a prod Yen, los filtros (estado-situaciones) tienen que coincidir con los de los labels (getSituacionStyle)
//Ya que van a haber situaciones nuevas que deben ser desglosadas.
export const creditosFilters = [
  {
    estado: "Todas",
    situaciones: [],
  },
  {
    estado: "En análisis",
    situaciones: [
      codigo(ESituacionOperacion.En_Analisis),
      codigo(ESituacionOperacion.Informes_Pendientes),
    ],
  },
  {
    estado: "Rechazadas",
    situaciones: [
      codigo(ESituacionOperacion.Rechazada),
      codigo(ESituacionOperacion.Rechazada_Definitivamente),
    ],
  },
  {
    estado: "Desistidas",
    situaciones: [
      codigo(ESituacionOperacion.Desistida),
      codigo(ESituacionOperacion.Desistida_por_tiempo),
    ],
  },
  {
    estado: "Aprobadas",
    situaciones: [
      codigo(ESituacionOperacion.Aprobada),
      codigo(ESituacionOperacion.Confeccion_Solicitada),
      codigo(ESituacionOperacion.Prenda_Confeccionada),
      codigo(ESituacionOperacion.Liquidacion_solicitada),
    ],
  },
  {
    estado: "Incompletas",
    situaciones: [
      codigo(ESituacionOperacion.Carga_Incompleta),
      codigo(ESituacionOperacion.No_Apto_Habilitado),
    ],
  },
  {
    estado: "Sin prendas",
    situaciones: [codigo(ESituacionOperacion.Liquidada)],
  },
];

const FiltroCreditosEstado = ({ filter, onChange }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (filtro) => {
    onChange(filtro);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        onClick={handleClickListItem}
        style={{
          display: "flex",
          cursor: "pointer",
        }}
      >
        <Typography
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
            lineHeight: 1.2,
            color: "#663EA8",
            opacity: 0.7,
            fontSize: pxToRem(15),
          }}
        >
          {filter.estado}
          <ArrowDownIcon color="primary" />
        </Typography>
      </div>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        classes={{ paper: classes.paper, list: classes.list }}
      >
        {creditosFilters.map((f) => (
          <MenuItem
            key={f.estado}
            selected={f === filter.situaciones}
            onClick={() => handleMenuItemClick(f)}
            classes={{ root: classes.root, selected: classes.selected }}
          >
            {f.estado}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FiltroCreditosEstado;

const useStyles = makeStyles({
  paper: {
    boxShadow: "0px 0px 6px rgba(162, 138, 201, 0.25)",
    borderRadius: pxToRem(8),
    padding: pxToRem(4),
  },
  list: { padding: 0 },
  root: {
    borderRadius: pxToRem(4),
    fontSize: pxToRem(15),
    lineHeight: pxToRem(24),
    fontWeight: "bold",
    color: "#9294AA",
    "&:hover": {
      backgroundColor: "#EFEBF6",
    },
  },
  selected: {
    color: "#7644C9",
    backgroundColor: "#EFEBF6 !important",
  },
});
